import NoticeList from '../../../features/customer/noticelist/NoticeList';

const NoticePage = ({ history }) => {
  return (
    <>
      <NoticeList history={history} />
    </>
  );
};

export default NoticePage;
